module.exports = __webpack_public_path__ + "img/3.001ab4ac.jpg";